<template>
	<div class="modal fade" id="modal-bilhetagem">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Detalhes da ligação</h4>
                    <button type="button" class="close" data-dismiss="modal">×</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <table class="table table-sm">
                                <tbody><tr>
                                    <td id="LOG-ID"><b>Unique ID</b>: {{ last_status.UNIQUEID }}</td>
                                    <td id="LOG-DATE"><b>Data</b>: {{ last_status.DATE | moment("DD/MM/YYYY") }}</td>
                                    <td id="LOG-INI"><b>Início</b>: {{ last_status.TIMESTART }}</td>
                                    <td id="LOG-FIM"><b>Fim</b>: {{ last_status.TIMEEND }}</td>
                                </tr>
                                <tr>
                                    <td id="LOG-ORIGEM"><b>Origem</b>: {{ last_status.ORIGIN }}</td>
                                    <td id="LOG-DESTINO"><b>Destino</b>: {{ last_status.DESTINO }}</td>
                                    <td id="LOG-C-IN"><b>Canal IN</b>: {{ last_status.CHANNEL_IN }}</td>
                                    <td id="LOG-C-OUT"><b>Canal OUT</b>: {{ last_status.CHANNEL_OUT }}</td>
                                </tr>
                            </tbody></table>
                        </div>
                    </div>
                    <hr>

                    <!-- Table -->
                    <div class="row">
                        <table class="table table-striped table-sm">
                            <thead align="center">
                                <tr>
                                    <th>ID</th>
                                    <th>DESTINO</th>
                                    <th>STATUS</th>
                                </tr>
                            </thead>

                            <tbody v-if="status" align="center">
                                <tr v-for="(sts, index) in status.result" :key="index">
                                    <td>{{ sts.ID }}</td>
                                    <td>{{ sts.DESTINO }}</td>
                                    <td>{{ sts.DATA_INPUT }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
		</div>
	</div>
</template>

<script>
	import api     from "@/mixins/api.js"
	import replace from "@/mixins/replace.js"

	export default {
		name: "modal-bilhetagem",
        mixins: [ api, replace ],
        
        data() { return {
            status: null,
            last_status: {}
        }},

		methods: {
            async load(payload) {
                this.status = null
                this.last_status = {}

                this.status = await this.GET("Dialstatus", `Uniqueid?uniqueid=${payload}`)
                this.last_status = this.status.result[ this.status.result.length - 1 ]

                $("#modal-bilhetagem").modal()
            },
        }
	}
</script>

<style scoped>
</style>
